export default __webpack_public_path__ + "static/media/misc-pantry2-2048w.636c74c5.png";